import { render, staticRenderFns } from "./SysUserPhoneBindList.vue?vue&type=template&id=490703bd&scoped=true&"
import script from "./SysUserPhoneBindList.vue?vue&type=script&lang=js&"
export * from "./SysUserPhoneBindList.vue?vue&type=script&lang=js&"
import style0 from "./SysUserPhoneBindList.vue?vue&type=style&index=0&id=490703bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490703bd",
  null
  
)

export default component.exports